import Button from '../../../forecast-app/shared/components/buttons/button/button';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../../constants';
import React from 'react';
import {useIntl} from 'react-intl';
import KeepEmptyPlaceholder from '../components/KeepEmptyPlaceholder';

export default ({pageComponent}) => {
	const {keepEmptyPlaceholder} = pageComponent.state;
	const {formatMessage} = useIntl();

	const setManual = () => {
		pageComponent.setState({
			keepEmptyPlaceholder: !keepEmptyPlaceholder,
		});
	};

	return (
		<div className="staffing-mode-footer">
			<div className="actions">
				<KeepEmptyPlaceholder isChecked={keepEmptyPlaceholder} changeIsChecked={setManual} />

				<Button
					text={formatMessage({id: 'common.exit'})}
					onClick={pageComponent.exitStaffingMode.bind(pageComponent)}
					buttonStyle={BUTTON_STYLE.FILLED}
					colorTheme={BUTTON_COLOR.WHITE}
				/>

				<Button
					text={formatMessage({id: 'scheduling.placeholders.staffing.save_and_exit'})}
					onClick={pageComponent.saveStaffingMode.bind(pageComponent)}
					buttonStyle={BUTTON_STYLE.FILLED}
					colorTheme={BUTTON_COLOR.GREEN_APPROVE}
				/>
			</div>
		</div>
	);
};
